import { render, staticRenderFns } from "./correctness_icon.vue?vue&type=template&id=d6b33d96&scoped=true&"
import script from "./correctness_icon.vue?vue&type=script&lang=ts&"
export * from "./correctness_icon.vue?vue&type=script&lang=ts&"
import style0 from "./correctness_icon.vue?vue&type=style&index=0&id=d6b33d96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b33d96",
  null
  
)

export default component.exports